import { render, staticRenderFns } from "./RestoreInventoryDefaultCostsComponent.vue?vue&type=template&id=3dbfbef8&scoped=true"
import script from "./RestoreInventoryDefaultCostsComponent.vue?vue&type=script&lang=js"
export * from "./RestoreInventoryDefaultCostsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbfbef8",
  null
  
)

export default component.exports